import { Link } from "gatsby";
import PropTypes from "prop-types";
import React from "react";
const moment = require(`moment`);

const LatestBlogPostsComponent = ({ data }) => {
    const { edges } = data;

    return (
        <>
            <div className="hidden md:flex justify-between pb-4 md:pb-8 md:mb-4 border-b border-gray-200 dark:border-gray-700">
                <div className="space-y-4">
                    <h2 className="flex font-bold text-3xl">Latest posts</h2>
                </div>
                <div className="pt-2 items-center justify-end text-base leading-6 font-medium">
                    <a aria-label="All posts" href="/Blog">
                        <span className="hidden md:inline-block">View all posts</span> →
                    </a>
                </div>
            </div>
            <div>
                <ul>
                    {edges.map(({ node }) => {
                    return (
                        <li key={node.fields.slug} className="py-4">
                            <article>
                                <div className="space-y-2 xl:space-y-0 xl:items-baseline">
                                    <dl>
                                        <dt className="sr-only">Published on</dt>
                                        <dd className="text-base font-medium leading-6 text-gray-500 dark:text-gray-400">
                                            <time dateTime={moment(node.frontmatter.date).format("YYYY-MM-DDTHH:mm:ssTZD")}>{moment(node.frontmatter.date).format("MMM DD, YYYY")}</time>
                                        </dd>
                                    </dl>
                                    <div className="space-y-5 xl:col-span-3">
                                        <div className="space-y-3">
                                            <div>
                                                <h3 className="text-2xl font-bold mb-1 tracking-tight">
                                                    <Link
                                                        to={node.fields.slug}
                                                        className="text-gray-900 dark:text-gray-100 hover:underline">
                                                        {node.frontmatter.title}
                                                    </Link> →
                                                </h3>
                                            </div>
                                            <div className="prose text-gray-500 max-w-none dark:text-gray-400">
                                                {node.frontmatter.summary}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </article>
                        </li>
                    )
                    })}
                </ul>
            </div>
        </>
        
    )
}

LatestBlogPostsComponent.propTypes = {
    data: PropTypes.object
}

export default LatestBlogPostsComponent